export const STATE_PERSISTENCE_SERVICE_TOKEN = 'STATE_PERSISTENCE_SERVICE_TOKEN';
export interface IStatePersistenceService {
  getState(id: string): Promise<unknown>;
  saveState(id: string, state: unknown): Promise<unknown>;
}
